import { RootState } from 'models';

const getSelectedCompanyForRoles = (state: RootState) => state.configurator.rolesUserCompany.selectedCompanyIdForRoles;

const getCompaniesForRoles = (state: RootState) => state.configurator.rolesUserCompany.companiesForRoles;

const getUsersForCompanyRoles = (state: RootState) => state.configurator.rolesUserCompany.usersForCompanyRoles;

const getSelectedUserForRoles = (state: RootState) => state.configurator.rolesUserCompany.selectedUserForRoles;

const getUserAvailableRoles = (state: RootState) => state.configurator.rolesUserCompany.userAvailableRoles;

const getTransformedUserRows = (state: RootState) => state.configurator.rolesUserCompany.transformedUserRows;

const getIsEditingUserRows = (state: RootState) => state.configurator.rolesUserCompany.isEditingUserRows;

const getEditRowIdUserRoles = (state: RootState) => state.configurator.rolesUserCompany.editRowId;

const getOpenRowId = (state: RootState) => state.configurator.rolesUserCompany.openRowId;

const getExternalSelectedUserId = (state: RootState) => state.configurator.rolesUserCompany.externalSelectedUserId;

const getSelectedProgram = (state: RootState) => state.configurator.rolesUserCompany.selectedProgram;

export default {
  getSelectedCompanyForRoles,
  getCompaniesForRoles,
  getUsersForCompanyRoles,
  getSelectedUserForRoles,
  getUserAvailableRoles,
  getTransformedUserRows,
  getEditRowIdUserRoles,
  getOpenRowId,
  getExternalSelectedUserId,
  getIsEditingUserRows,
  getSelectedProgram,
};
